var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375,22.375a19,19,0,1,0,19-19A19,19,0,0,0,3.375,22.375Zm26.408-3.964a1.77,1.77,0,0,1,2.494,0,1.741,1.741,0,0,1,.512,1.242,1.772,1.772,0,0,1-.521,1.251l-8.614,8.587a1.761,1.761,0,0,1-2.43-.055l-8.742-8.714a1.763,1.763,0,1,1,2.494-2.494l7.408,7.481Z",
    transform: "translate(41.375 -3.375) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.25ace7158353b61a106e7e851b2a7081.svg";
export { ForwardRef as ReactComponent };